import * as React from 'react';
import { themr } from 'react-css-themr';
export const defaultListTheme = {
    root: 'list pl0 flex flex-wrap nl3 nr3',
    itemWrapper: 'w-100 w-50-m w-third-l pa3',
};
export function DumpList({ entities, renderItem, theme = {}, }) {
    return (React.createElement("ul", { className: theme.root }, entities.map((entity, idx) => (React.createElement("li", { key: idx, className: theme.itemWrapper }, renderItem(entity, idx))))));
}
export default themr('List', {}, {
    composeTheme: 'softly',
})(DumpList);
//# sourceMappingURL=index.js.map